import React from 'react';
import PropTypes from 'prop-types';
import { sortAlphaObj } from '../../lib/helpers';

const DataBoxStackedAssociationComponent = (props) => {
  const { assoc } = props;
  const renderItems = assoc.items.sort(sortAlphaObj).map((item) => {
    if (item.children.length > 0) {
      const renderChildren = item.children.sort(sortAlphaObj).map((c) => (
        <li key={c.id}>
          <a href={c.url}>
            {c.name}
          </a>
        </li>
      ));

      return (
        <li key={item.id}>
          <a href={item.url}>
            {item.name}
          </a>
          <ul>
            {renderChildren}
          </ul>
        </li>
      );
    }

    return (
      <li key={item.id}>
        <a href={item.url}>
          {item.name}
        </a>
      </li>
    );
  });

  return (
    <div>
      <ul>
        {renderItems}
      </ul>
    </div>
  );
};

DataBoxStackedAssociationComponent.defaultProps = {

};

DataBoxStackedAssociationComponent.propTypes = {
  assoc: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};

DataBoxStackedAssociationComponent.displayName = 'DataBoxStackedAssociationComponent';
export default DataBoxStackedAssociationComponent;
